import React, { useCallback } from 'react';

import type { Invitees } from '@atlassian/invite-prompt';
import { InviteSuccessFlag } from '@atlassian/invite-prompt';

import type { FlagsStateContainer } from '@confluence/flags';

const PRODUCT = 'jira-software';

export const useInviteSuccessFlag = (flags?: FlagsStateContainer) => {
	return useCallback(
		(invitees: Invitees) => {
			const dismiss = (id: string | number) => flags?.hideFlag(id);

			flags?.showFlag({
				customComponent: (props) => (
					<InviteSuccessFlag
						{...props}
						id={props.id}
						invitees={invitees}
						product={PRODUCT}
						onDismiss={dismiss}
					/>
				),
			});
		},
		[flags],
	);
};
